import React, { Component } from "react";
import {
    Alert,
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    LinearProgress,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {
    Add,
    Close,
    Delete,
    Edit,
    Refresh,
    Visibility,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import axios from "axios";
import Api from "../../customlib/Api";

const CATEGORIES = [
    { value: "menu", label: "Menu" },
    { value: "ask_order", label: "Ask Order" },
    { value: "ticket_created", label: "Ticket Created" },
    { value: "redirect", label: "Redirect" },
    { value: "handling", label: "Handling" },
    { value: "satisfaction", label: "Satisfaction" },
    { value: "tracking", label: "Tracking" },
    { value: "finance", label: "Finance" },
];

const EMPTY_FORM = {
    trigger_key: "",
    category: "",
    label: "",
    message_template: "",
    hsm_name: "",
    is_active: true,
};

class CsAutoReplyTemplates extends Component {
    state = {
        loading: false,
        templates: [],
        // Dialog
        dialogOpen: false,
        dialogMode: "create", // create | edit | view
        form: { ...EMPTY_FORM },
        editId: null,
        saving: false,
        // Delete confirm
        deleteDialogOpen: false,
        deleteTarget: null,
        deleting: false,
        // Filter
        filterCategory: "",
        filterSearch: "",
        // Snackbar
        snackbar: { open: false, message: "", severity: "success" },
    };

    componentDidMount() {
        this.loadTemplates();
    }

    loadTemplates = () => {
        this.setState({ loading: true });
        axios
            .get(Api.csAutoReplyList(), Api.getRequestHeader())
            .then((res) => {
                const data = res.data || {};
                if (data.success) {
                    this.setState({
                        loading: false,
                        templates: (data.data && data.data.templates) || [],
                    });
                } else {
                    this.setState({ loading: false });
                    this.showSnackbar(data.message || "Gagal memuat templates", "error");
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                this.showSnackbar(err.message || "Network error", "error");
            });
    };

    showSnackbar = (message, severity = "success") => {
        this.setState({ snackbar: { open: true, message, severity } });
    };

    // ============================================================
    // Dialog handlers
    // ============================================================

    openCreate = () => {
        this.setState({
            dialogOpen: true,
            dialogMode: "create",
            form: { ...EMPTY_FORM },
            editId: null,
        });
    };

    openEdit = (row) => {
        this.setState({
            dialogOpen: true,
            dialogMode: "edit",
            editId: row.id,
            form: {
                trigger_key: row.trigger_key || "",
                category: row.category || "",
                label: row.label || "",
                message_template: row.message_template || "",
                hsm_name: row.hsm_name || "",
                is_active: row.is_active !== false,
            },
        });
    };

    openView = (row) => {
        this.setState({
            dialogOpen: true,
            dialogMode: "view",
            editId: row.id,
            form: {
                trigger_key: row.trigger_key || "",
                category: row.category || "",
                label: row.label || "",
                message_template: row.message_template || "",
                hsm_name: row.hsm_name || "",
                is_active: row.is_active !== false,
            },
        });
    };

    closeDialog = () => {
        this.setState({ dialogOpen: false });
    };

    handleFormChange = (field, value) => {
        this.setState({ form: { ...this.state.form, [field]: value } });
    };

    handleSave = () => {
        const { form, dialogMode, editId } = this.state;

        if (!form.trigger_key.trim()) {
            this.showSnackbar("Trigger Key wajib diisi", "error");
            return;
        }
        if (!form.message_template.trim()) {
            this.showSnackbar("Message Template wajib diisi", "error");
            return;
        }

        this.setState({ saving: true });

        const payload = {
            trigger_key: form.trigger_key.trim(),
            category: form.category || null,
            label: form.label.trim() || null,
            message_template: form.message_template,
            hsm_name: form.hsm_name.trim() || null,
            is_active: form.is_active,
        };

        const request =
            dialogMode === "create"
                ? axios.post(Api.csAutoReplyCreate(), payload, Api.getRequestHeaderJson())
                : axios.put(Api.csAutoReplyUpdate(editId), payload, Api.getRequestHeaderJson());

        request
            .then((res) => {
                const data = res.data || {};
                if (data.success) {
                    this.setState({ saving: false, dialogOpen: false });
                    this.showSnackbar(
                        dialogMode === "create" ? "Template berhasil dibuat" : "Template berhasil diupdate",
                        "success"
                    );
                    this.loadTemplates();
                } else {
                    this.setState({ saving: false });
                    this.showSnackbar(data.message || "Gagal menyimpan", "error");
                }
            })
            .catch((err) => {
                this.setState({ saving: false });
                this.showSnackbar(
                    (err.response && err.response.data && err.response.data.message) ||
                        err.message ||
                        "Network error",
                    "error"
                );
            });
    };

    // ============================================================
    // Delete
    // ============================================================

    openDeleteConfirm = (row) => {
        this.setState({ deleteDialogOpen: true, deleteTarget: row });
    };

    closeDeleteConfirm = () => {
        this.setState({ deleteDialogOpen: false, deleteTarget: null });
    };

    handleDelete = () => {
        const { deleteTarget } = this.state;
        if (!deleteTarget) return;

        this.setState({ deleting: true });
        axios
            .delete(Api.csAutoReplyDelete(deleteTarget.id), Api.getRequestHeader())
            .then((res) => {
                const data = res.data || {};
                if (data.success) {
                    this.setState({ deleting: false, deleteDialogOpen: false, deleteTarget: null });
                    this.showSnackbar("Template berhasil dihapus", "success");
                    this.loadTemplates();
                } else {
                    this.setState({ deleting: false });
                    this.showSnackbar(data.message || "Gagal menghapus", "error");
                }
            })
            .catch((err) => {
                this.setState({ deleting: false });
                this.showSnackbar(err.message || "Network error", "error");
            });
    };

    // ============================================================
    // Toggle active
    // ============================================================

    toggleActive = (row) => {
        const payload = { is_active: !row.is_active };
        axios
            .put(Api.csAutoReplyUpdate(row.id), payload, Api.getRequestHeaderJson())
            .then((res) => {
                const data = res.data || {};
                if (data.success) {
                    this.loadTemplates();
                } else {
                    this.showSnackbar(data.message || "Gagal toggle", "error");
                }
            })
            .catch((err) => {
                this.showSnackbar(err.message || "Network error", "error");
            });
    };

    // ============================================================
    // Filter
    // ============================================================

    getFilteredTemplates = () => {
        const { templates, filterCategory, filterSearch } = this.state;
        let filtered = templates;

        if (filterCategory) {
            filtered = filtered.filter((t) => t.category === filterCategory);
        }
        if (filterSearch.trim()) {
            const q = filterSearch.toLowerCase();
            filtered = filtered.filter(
                (t) =>
                    (t.trigger_key || "").toLowerCase().includes(q) ||
                    (t.label || "").toLowerCase().includes(q) ||
                    (t.message_template || "").toLowerCase().includes(q)
            );
        }
        return filtered;
    };

    // ============================================================
    // Render
    // ============================================================

    renderCategoryChip = (category) => {
        const colorMap = {
            menu: "primary",
            ask_order: "info",
            ticket_created: "success",
            redirect: "warning",
            handling: "secondary",
            satisfaction: "error",
            tracking: "default",
            finance: "default",
        };
        return (
            <Chip
                size="small"
                label={category || "-"}
                color={colorMap[category] || "default"}
                variant="outlined"
            />
        );
    };

    render() {
        const {
            loading,
            snackbar,
            dialogOpen,
            dialogMode,
            form,
            saving,
            deleteDialogOpen,
            deleteTarget,
            deleting,
            filterCategory,
            filterSearch,
        } = this.state;

        const filtered = this.getFilteredTemplates();

        return (
            <Paper sx={{ padding: "20px", margin: "10px" }}>
                {/* Header */}
                <Box>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item sm={9} xs={7}>
                            <Typography variant="h5" fontWeight={600}>
                                CS Auto-Reply Templates
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Kelola template pesan otomatis (HSM) yang dikirim ke customer.
                            </Typography>
                        </Grid>
                        <Grid item sm={3} xs={5} textAlign="right">
                            <Tooltip title="Reload">
                                <span>
                                    <IconButton onClick={this.loadTemplates} disabled={loading}>
                                        <Refresh />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Tutup">
                                {this.props.onClose ? (
                                    <IconButton color="error" onClick={this.props.onClose}>
                                        <Close />
                                    </IconButton>
                                ) : (
                                    <Link to="/">
                                        <IconButton color="error">
                                            <Close />
                                        </IconButton>
                                    </Link>
                                )}
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Box>
                <Divider sx={{ mb: 2 }} />

                {loading && <LinearProgress sx={{ mb: 2 }} />}

                {/* Toolbar: filter + add */}
                <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                    <TextField
                        size="small"
                        placeholder="Cari trigger / label / isi..."
                        value={filterSearch}
                        onChange={(e) => this.setState({ filterSearch: e.target.value })}
                        sx={{ minWidth: 220 }}
                    />
                    <FormControl size="small" sx={{ minWidth: 160 }}>
                        <InputLabel>Kategori</InputLabel>
                        <Select
                            value={filterCategory}
                            label="Kategori"
                            onChange={(e) => this.setState({ filterCategory: e.target.value })}
                        >
                            <MenuItem value="">Semua</MenuItem>
                            {CATEGORIES.map((c) => (
                                <MenuItem key={c.value} value={c.value}>
                                    {c.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Box sx={{ flexGrow: 1 }} />
                    <Button variant="contained" startIcon={<Add />} onClick={this.openCreate}>
                        Tambah Template
                    </Button>
                </Box>

                {/* Table */}
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: "grey.100" }}>
                                <TableCell width={40}>#</TableCell>
                                <TableCell>Trigger Key</TableCell>
                                <TableCell>Label</TableCell>
                                <TableCell>Kategori</TableCell>
                                <TableCell>Pesan (preview)</TableCell>
                                <TableCell width={80} align="center">Aktif</TableCell>
                                <TableCell width={130} align="center">Aksi</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filtered.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        <Typography variant="body2" color="text.secondary" py={3}>
                                            {loading ? "Memuat..." : "Tidak ada template ditemukan."}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                            {filtered.map((row, idx) => (
                                <TableRow key={row.id} hover>
                                    <TableCell>{idx + 1}</TableCell>
                                    <TableCell>
                                        <Typography variant="body2" fontFamily="monospace" fontSize={12}>
                                            {row.trigger_key}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                                            {row.label || "-"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>{this.renderCategoryChip(row.category)}</TableCell>
                                    <TableCell>
                                        <Typography
                                            variant="body2"
                                            noWrap
                                            sx={{ maxWidth: 280, color: "text.secondary" }}
                                        >
                                            {(row.message_template || "").substring(0, 80)}
                                            {(row.message_template || "").length > 80 ? "..." : ""}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Switch
                                            size="small"
                                            checked={row.is_active !== false}
                                            onChange={() => this.toggleActive(row)}
                                            color="success"
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Lihat">
                                            <IconButton size="small" onClick={() => this.openView(row)}>
                                                <Visibility fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Edit">
                                            <IconButton size="small" color="primary" onClick={() => this.openEdit(row)}>
                                                <Edit fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Hapus">
                                            <IconButton size="small" color="error" onClick={() => this.openDeleteConfirm(row)}>
                                                <Delete fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
                    Total: {filtered.length} template
                    {filterCategory || filterSearch.trim() ? ` (filtered dari ${this.state.templates.length})` : ""}
                </Typography>

                {/* Create/Edit/View Dialog */}
                <Dialog open={dialogOpen} onClose={this.closeDialog} maxWidth="md" fullWidth>
                    <DialogTitle>
                        {dialogMode === "create"
                            ? "Tambah Template Baru"
                            : dialogMode === "edit"
                            ? "Edit Template"
                            : "Detail Template"}
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Trigger Key *"
                                    value={form.trigger_key}
                                    onChange={(e) => this.handleFormChange("trigger_key", e.target.value)}
                                    disabled={dialogMode === "view"}
                                    helperText="Identifier unik (contoh: complaint_ask_order)"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth size="small">
                                    <InputLabel shrink>Kategori</InputLabel>
                                    <Select
                                        value={form.category}
                                        label="Kategori"
                                        onChange={(e) => this.handleFormChange("category", e.target.value)}
                                        disabled={dialogMode === "view"}
                                        displayEmpty
                                    >
                                        <MenuItem value="">— Pilih —</MenuItem>
                                        {CATEGORIES.map((c) => (
                                            <MenuItem key={c.value} value={c.value}>
                                                {c.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Label (deskripsi singkat)"
                                    value={form.label}
                                    onChange={(e) => this.handleFormChange("label", e.target.value)}
                                    disabled={dialogMode === "view"}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="HSM Name (vendor)"
                                    value={form.hsm_name}
                                    onChange={(e) => this.handleFormChange("hsm_name", e.target.value)}
                                    disabled={dialogMode === "view"}
                                    placeholder="Opsional"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={6}
                                    label="Message Template *"
                                    value={form.message_template}
                                    onChange={(e) => this.handleFormChange("message_template", e.target.value)}
                                    disabled={dialogMode === "view"}
                                    helperText="Gunakan {{variable}} untuk placeholder. Contoh: {{queue_label}}, {{official_cs_wa}}, {{option_label}}, {{queue_url}}, {{live_tracking_url}}"
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={form.is_active}
                                            onChange={(e) => this.handleFormChange("is_active", e.target.checked)}
                                            disabled={dialogMode === "view"}
                                            color="success"
                                        />
                                    }
                                    label="Aktif"
                                />
                            </Grid>
                            {dialogMode === "view" && (
                                <Grid item xs={12}>
                                    <Alert severity="info" variant="outlined">
                                        <Typography variant="subtitle2" fontWeight={600}>Preview Pesan:</Typography>
                                        <Box
                                            sx={{
                                                mt: 1,
                                                p: 1.5,
                                                bgcolor: "#e8f5e9",
                                                borderRadius: 2,
                                                whiteSpace: "pre-wrap",
                                                fontFamily: "monospace",
                                                fontSize: 13,
                                            }}
                                        >
                                            {form.message_template || "(kosong)"}
                                        </Box>
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeDialog} color="inherit">
                            {dialogMode === "view" ? "Tutup" : "Batal"}
                        </Button>
                        {dialogMode !== "view" && (
                            <Button
                                variant="contained"
                                onClick={this.handleSave}
                                disabled={saving}
                                startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
                            >
                                {saving ? "Menyimpan..." : dialogMode === "create" ? "Buat" : "Simpan"}
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                {/* Delete Confirm Dialog */}
                <Dialog open={deleteDialogOpen} onClose={this.closeDeleteConfirm} maxWidth="xs">
                    <DialogTitle>Hapus Template?</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2">
                            Yakin ingin menghapus template{" "}
                            <strong>{deleteTarget && deleteTarget.trigger_key}</strong>?
                        </Typography>
                        <Typography variant="caption" color="error">
                            Aksi ini tidak bisa di-undo.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeDeleteConfirm} color="inherit" disabled={deleting}>
                            Batal
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.handleDelete}
                            disabled={deleting}
                            startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : <Delete />}
                        >
                            {deleting ? "Menghapus..." : "Hapus"}
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Snackbar */}
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={4000}
                    onClose={() => this.setState({ snackbar: { ...snackbar, open: false } })}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                >
                    <Alert
                        severity={snackbar.severity}
                        onClose={() => this.setState({ snackbar: { ...snackbar, open: false } })}
                        sx={{ width: "100%" }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Paper>
        );
    }
}

export default CsAutoReplyTemplates;
